export default __webpack_public_path__ + "static/media/logo.963b74c1.png";